import React from "react";

// Una de las dos listas del alcance de un cierre: sus semanas de producción o
// sus periodos de inventario de almacén
export const ListaAlcance = ({ titulo, items, vacio }) => (
    <div className="formulario-field">
        <label className="formulario-field__label">{titulo}</label>

        {items.length ? (
            <ul className="comparativo-mensual__alcance-lista">
                {items.map((item) => (
                    <li key={item}>{item}</li>
                ))}
            </ul>
        ) : (
            <div className="comparativo-mensual__alcance-vacio">{vacio}</div>
        )}
    </div>
);
